<script lang="ts" setup>
import { CATALOG_PAGE_TYPES } from '~/constants/catalogPageTypes';
import type { FavoriteItemsListResponse } from '~/types/Favorite';

const route = useRoute();
const catalogStore = useCatalogStore();

const favoritesResponse = ref<FavoriteItemsListResponse | null>(null);

const data = await catalogStore.getFavorites();

await processData(data);

async function processData(data: FavoriteItemsListResponse | null) {
  if (data) {
    if (import.meta.client) setTimeout(() => window.scrollTo(0, 0), 10);

    catalogStore.currentPageType = CATALOG_PAGE_TYPES.FAVORITE;
    favoritesResponse.value = data;
  }
}

watch(
  () => route.query,
  async () => {
    const data = await catalogStore.getFavorites();

    await processData(data);
  },
);
</script>

<template>
  <section class="favorites-page">
    <CatalogBreadcrumbsBlock :breadcrumbs="favoritesResponse?.data.breadcrumbs" />

    <div class="flex items-center gap-2">
      <BackButton />

      <h1>Избранное</h1>
    </div>

    <ProductsListing
      v-if="favoritesResponse?.data.offers.length"
      :offers="favoritesResponse.data.offers"
      :pagination="favoritesResponse.data.pagination"
      :sort-options="favoritesResponse.data.sorting_options"
    />

    <div
      v-else
      class="flex flex-col items-center justify-center gap-4 h-full"
    >
      <div class="flex items-center justify-center border-1 border-hell-black-60 rounded-full size-20">
        <SvgoHeart
          :font-controlled="false"
          class="size-16 text-label-red mt-2"
        />
      </div>

      <h1>Здесь пока пусто</h1>

      <p class="text-center">
        Чтобы добавлять товары в избранное, нажимайте на
        <SvgoHeart
          :font-controlled="false"
          class="inline size-6 text-hell-black-80"
          filled
        />
      </p>

      <TheBtn
        class="w-40"
        to="/catalog"
      >
        В каталог
      </TheBtn>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.favorites-page {
  @include inner-content;

  gap: 16px;
  height: 100%;
}
</style>
